const NewBadge = ({ label }) => {
    return (
        <span className="inline-flex items-center rounded-full px-2 py-1 text-white bg-teal-500 text-xs">
            {label}
        </span>
    );
};

export default NewBadge;
